/**
 * Retrieves a section using the Section Rendering API
 *
 * @param {String} url - URL of the section to return
 * @returns HTMLElement
 */
export const fetchSection = (url) =>
  fetch(url)
    .then((res) => res.text())
    .then((html) =>
      new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".shopify-section")
    );


class ColourVariants extends HTMLElement {
  constructor() {
    super();

    this.drawerMatchingProducts = document.querySelector('drawer-matching-products');
  }

  connectedCallback() {
    this.initialise();
    this.selectionActions();
  }

  loadingState(element, isLoading) {
    if (isLoading == true) {
      element.classList.add('loading');
    }
    else {
      element.classList.remove('loading');
    }
  }

  selectionActions() {
    this.addEventListener('click', (event) => {
      if (event.target.hasAttribute('data-card-variant-select')) {
        this.querySelectorAll('[data-card-variant-select]').forEach(variant => {
          variant.classList.remove('active');
        });

        event.target.classList.add('active');
      }

      if (event.target.hasAttribute('data-card-variant-add')) {
        this.querySelectorAll('[data-card-variant-select]').forEach(variant => {
          if (variant.classList.contains('active')) {
            this.loadingState(this.drawerMatchingProducts, true);
            this.selectionAddToCart(variant.getAttribute('data-id'));
          }
        });
      }
    })
  }

  selectionAddToCart(productId) {
    let formData = {
      'items': [{
        'id': productId,
        'quantity': 1
       }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', { 
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then(response => {
      this.drawerMatchingProducts.querySelector('.bbc-drawer-matching-products-overlay .success').classList.add('active');
      this.drawerMatchingProducts.querySelector('.bbc-drawer-matching-products-overlay .error').classList.remove('active');
      document.dispatchEvent(new Event('matching-products:add'));

      setTimeout(() => {
        this.loadingState(this.drawerMatchingProducts, false);
      }, '4000');
    })
    .catch((error) => {
      this.drawerMatchingProducts.querySelector('.bbc-drawer-matching-products-overlay .success').classList.remove('active');
      this.drawerMatchingProducts.querySelector('.bbc-drawer-matching-products-overlay .error').classList.add('active');
      this.drawerMatchingProducts.querySelector('.bbc-drawer-matching-products-overlay .error').innerHTML = error.description;

      setTimeout(() => {
        this.loadingState(this.drawerMatchingProducts, false);
      }, '4000');
    })
  }

  initialise() {
    this.querySelectorAll("[data-variant]").forEach((el) => {
      el.addEventListener("click", this.handleVariantClick.bind(this));
    });
  }

  async handleVariantClick(e) {
    this.productCard = this.querySelector("[data-product-card]");
    fetchSection(
      `/products/${e.target.dataset.variant}?section_id=collection-grid-item`
    ).then((section) => {
      if (section.querySelector("[data-product-badges]") !== null) {
        this.productCard.querySelector("[data-product-badges]").innerHTML = section.querySelector("[data-product-badges]").innerHTML;
      }

      if(section.querySelector("[data-product-images]") !== null) {
        this.productCard.querySelector("[data-product-images]").innerHTML = section.querySelector("[data-product-images]").innerHTML;
        this.productCard.querySelector("[data-product-images]").href = section.querySelector("[data-product-images]").href;
      }

      if(section.querySelector("[data-product-overlay]") !== null) {
        this.productCard.querySelector("[data-product-overlay]").innerHTML = section.querySelector("[data-product-overlay]").innerHTML;
      }

      if(section.querySelector("[data-light-badges]") !== null) {
        this.productCard.querySelector("[data-light-badges]").innerHTML = section.querySelector("[data-light-badges]").innerHTML;
      }

      if(section.querySelector("[data-product-title]") !== null) {
        this.productCard.querySelector("[data-product-title]").innerHTML = section.querySelector("[data-product-title]").innerHTML;
      }

      if(section.querySelector("[data-product-price-parent]") !== null) {
        this.productCard.querySelector("[data-product-price-parent]").innerHTML = section.querySelector("[data-product-price-parent]").innerHTML;
      }

      if(section.querySelector("[data-product-price]") !== null) {
        this.productCard.querySelector("[data-product-price]").innerHTML = section.querySelector("[data-product-price]").innerHTML;
      }

      if(section.querySelector("[data-regular-price]") !== null) {
        this.productCard.querySelector("[data-regular-price]").innerHTML = section.querySelector("[data-regular-price]").innerHTML;
      }

      if(section.querySelector("[data-compare-price]") !== null) {
        this.productCard.querySelector("[data-compare-price]").innerHTML = section.querySelector("[data-compare-price]").innerHTML;
      }

      if(section.querySelector("[data-sold-out]") !== null) {
        this.productCard.querySelector("[data-sold-out]").innerHTML = section.querySelector("[data-sold-out]").innerHTML;
      }

      if(section.querySelector("[data-variant-id]") !== null) {
        this.productCard.querySelector("[data-variant-id]").innerHTML = section.querySelector("[data-variant-id]").innerHTML;
      }

      if(section.querySelector("[data-product-id]") !== null) {
        this.parentElement.dataset.productId = section.querySelector("[data-product-id]").dataset.productId;
      }

      if(section.querySelector("product-popup") !== null) {
        this.parentElement.querySelector("product-popup").innerHTML = section.querySelector("product-popup").innerHTML;
        this.parentElement.querySelector("product-popup").dataset.product = section.querySelector("product-popup").dataset.product;
        const event = new CustomEvent("productPopupLoaded");
        document.dispatchEvent(event);
      }

      this.querySelectorAll("[data-variant]").forEach((el) => {
        el.addEventListener("click", this.handleVariantClick.bind(this));
      });
    });
  }
}

customElements.define("colour-variants", ColourVariants);
